// extracted by mini-css-extract-plugin
module.exports = {"container":"NsTabsItems_container_2ecKb","item":"NsTabsItems_item_2UtL1","selected":"NsTabsItems_selected_2nqni"};